import React from 'react'
import './Loading.css'
// import garageLoading from '../../../public/assets/Images/GarageAnimation.svg'

export default function loading({text}){
  return (
    <div className='loading'>
      <div>
        <svg xmlSpace="preserve" viewBox="0 0 100 90" y="0px" x="0px" xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlns="http://www.w3.org/2000/svg" version="1.1"
          style={{height: '100%', width: '100%' ,background: 'rgba(241, 242, 243, 0)'}} width="200px" height="200px"
        >
          <style type="text/css">
            {
              `/* <![CDATA[ */
              @keyframes bounce {
                0% {
                  animation-timing-function: cubic-bezier(0.1361,0.2514,0.2175,0.8786);
                  transform: translate(0,0px) scaleY(1);
                }
                37% {
                  animation-timing-function: cubic-bezier(0.7674,0.1844,0.8382,0.7157);
                  transform: translate(0,-19.96px) scaleY(1);
                }
                72% {
                  animation-timing-function: cubic-bezier(0.1118,0.2149,0.2172,0.941);
                  transform: translate(0,0px) scaleY(1);
                }
                87% {
                  animation-timing-function: cubic-bezier(0.7494,0.2259,0.8209,0.6963);
                  transform: translate(0,19.92px) scaleY(0.5);
                }
                100% {
                  transform: translate(0,0px) scaleY(1);
                }
              }
              .green{
                fill: rgb(44, 140, 20);
              }
              .green2{
                fill: rgb(10, 67, 8);
              }
              .palidGreen{
                fill: rgb(157, 177, 137);
              }
              .palidGreen2{
                fill: rgb(79, 86, 59);
              }
              .anotherGreen{
                fill: rgb(96, 163, 99);
              }
              .brown{
                fill: rgb(224, 220, 184)
              }
              .yellow{
                stroke: rgb(172, 167, 48);
              }
              .red{
                stroke: rgb(152, 93, 78);
              }
              /* ]]> */`
            }
          </style>
          <g className="ldl-scale" style={{transformOrigin: '50% 50%', transform: 'rotate(0deg) scale(1, 1)'}}>
            <g className="ldl-ani"
              style={
                {
                  transformOrigin: '50px 50px',
                  transform: 'matrix(1, 0, 0, 1, 0, 0)',
                  animation: '1.5s linear 0s infinite reverse forwards running bounce'
                }
              }
            >
              <g className="ldl-layer">
                <g className="ldl-ani">
                  <g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <rect height="26.7" width="70.2" fill="#E0E0E0" y="54.2" x="14.9" className='brown'>
                        </rect>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <polygon points="83.3,30 16.7,30 7.5,54.2 92.5,54.2" fill="#77A4BD" className='palidGreen'>
                        </polygon>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <rect height="2.2" width="82.7" fill="#E0E0E0" y="80.8" x="9.3" className='brown'>
                        </rect>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <rect height="21.2" width="37.5" fill="#333333" y="59.7" x="21.3" className='green'>
                        </rect>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g className="ldl-layer">
                <g className="ldl-ani">
                  <g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <path
                          d="M38.1,76h1.1c0.3,0,0.6,0.3,0.6,0.6v1.8v1.8c0,0.3-0.3,0.6-0.6,0.6h-1.1c-0.3,0-0.6-0.3-0.6-0.6v-1.8v-1.8 C37.5,76.2,37.8,76,38.1,76z"
                          className='green2'></path>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <path
                          d="M28.3,76h-1.1c-0.3,0-0.6,0.3-0.6,0.6v1.8v1.8c0,0.3,0.3,0.6,0.6,0.6h1.1c0.3,0,0.6-0.3,0.6-0.6v-1.8v-1.8 C28.9,76.2,28.7,76,28.3,76z"
                          className='green2'></path>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <path
                          d="M40.4,78.4H26.1c-0.3,0-0.6-0.3-0.6-0.6V73c0-0.8,0.7-1.5,1.5-1.5h12.6c0.8,0,1.5,0.7,1.5,1.5v4.8 C41.1,78.1,40.8,78.4,40.4,78.4z"
                          fill="#E15B64" className='palidGreen2'></path>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <path d="M37.4,67.1h-8.2c-0.7,0-1.2,0.6-1.2,1.2v3.1h10.7v-3.1C38.6,67.7,38,67.1,37.4,67.1z"
                          fill="#FFFFFF" opacity="0.3" className='red'></path>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <path
                          d="M37.7,66.2h-8.9c-1.1,0-1.9,0.9-1.9,1.9v3.3h1v-3.1c0-0.7,0.6-1.2,1.2-1.2h8.2c0.7,0,1.2,0.6,1.2,1.2v3.1h1 v-3.3C39.6,67.1,38.7,66.2,37.7,66.2z"
                          fill="#E15B64" className='palidGreen2'></path>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <circle r="1.1" cy="73.3" cx="27.3" fill="#FFFFFF" className='red'></circle>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <circle r="1.1" cy="73.3" cx="39.1" fill="#FFFFFF" className='red'></circle>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <line y2="74" x2="37.2" y1="74" x1="29.3" strokeMiterlimit="10" strokeLinecap="round"
                          strokeWidth="0.4899" stroke="#FFFFFF" fill="none" className='red'></line>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <line y2="75.4" x2="37.2" y1="75.4" x1="29.3" strokeMiterlimit="10" strokeLinecap="round"
                          strokeWidth="0.4899" stroke="#FFFFFF" fill="none" className='red'></line>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <line y2="76.8" x2="37.2" y1="76.8" x1="29.3" strokeMiterlimit="10" strokeLinecap="round"
                          strokeWidth="0.4899" stroke="#FFFFFF" fill="none" className='red'></line>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g className="ldl-layer">
                <g className="ldl-ani">
                  <g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <rect height="21.2" width="11.2" fill="#66503A" y="59.7" x="66.6" className='anotherGreen'>
                        </rect>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <rect height="6" width="3" fill="#333333" y="61.5" x="68.4" className='green'></rect>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <rect height="6" width="3" fill="#333333" y="61.5" x="73.1" className='green'></rect>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <circle r="0.9" cy="70.5" cx="75.9" fill="#E0E0E0" className='brown'></circle>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g className="ldl-layer">
                <g className="ldl-ani">
                  <g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <polygon points="42.9,17 26.9,30.2 26.9,46 42.9,46 58.9,46 58.9,30.2" fill="#E0E0E0"
                          className='brown'></polygon>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <rect height="11.4" width="15.5" fill="#333333" y="31.5" x="35.2" className='green'>
                        </rect>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <rect height="11.4" width="2.3" fill="#E0E0E0" y="31.5" x="41.8" className='brown'>
                        </rect>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <polygon points="42.9,17 30.9,26.9 54.9,26.9" fill="#77A4BD" className='palidGreen'>
                        </polygon>
                      </g>
                    </g>
                    <g className="ldl-layer">
                      <g className="ldl-ani">
                        <polyline points="63.5,34.1 42.9,17 22.3,34.1" strokeMiterlimit="10" strokeWidth="3.8636"
                          stroke="#A0C8D7" fill="none" className='yellow'></polyline>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
      {/* <img src={ garageLoading } alt='loading'></img> */}
      <span>{text || 'loading, please wait...'}</span>
    </div>
  )
}